import { useEffect } from "react";

import { logger } from "../../shared/logger";
import * as transport from "../../transport";
import { getDeviceSettings } from "./shared/get-device-settings";
import { Route } from "./shared/route";
import { useApiClient } from "./shared/use-api-client";

const resolve = transport.Resolve<"Terminal_initialise">();

export default Route(
	{ query: "Terminal_initialise", interactive: false },
	function ({ headers: { deviceId } }) {
		const apiClient = useApiClient();

		useEffect(() => {
			(async () => {
				logger.debug("initialise: request", { deviceId });

				if (!deviceId) {
					return void resolve.Error("Setup Required", {
						message: "Not configured.",
					});
				}

				{
					const settings = await getDeviceSettings({ apiClient, deviceId });
					if (settings instanceof Error) {
						return void resolve.Error("Network Failure", {
							message: "Failed to load device configuration.",
						});
					}

					if (!settings) {
						return void resolve.Error("Setup Required", {
							message: "Not configured.",
						});
					}

					if (!settings.terminal) {
						return void resolve.Error("Setup Required", {
							message: "Not paired to a Zeller Terminal.",
						});
					}
				}

				return void resolve.Ok(true);
			})();
		}, [apiClient, deviceId]);

		return null;
	},
);
